import React from 'react';
import { Card, Box, Typography, Button } from '@mui/material';

interface PanelCardProps {
  title: React.ReactNode;
  action?: React.ReactNode;
  error?: string | null;
  onRetry?: () => void;
  children: React.ReactNode;
}

/** Titled card shell with an independent error state so one failing panel never blanks the page. */
const PanelCard: React.FC<PanelCardProps> = ({ title, action, error, onRetry, children }) => (
  <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2.5, pt: 2, pb: 1 }}>
      {typeof title === 'string'
        ? <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.dark' }}>{title}</Typography>
        : title}
      {action}
    </Box>
    <Box sx={{ flexGrow: 1, px: 2.5, pb: 2 }}>
      {error ? (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography color="error" sx={{ mb: 1 }}>{error}</Typography>
          {onRetry && <Button size="small" onClick={onRetry}>Retry</Button>}
        </Box>
      ) : children}
    </Box>
  </Card>
);

export default PanelCard;
